
import { Action } from 'redux';

import { isSetPreviousUrlAction } from '../actions/SetPreviousUrlReducerAction';

export const PreviousUrlInitialState: string = '';

export function previousUrlReducer(
  previousState: string = PreviousUrlInitialState,
  action: Action
): string  {
  if (isSetPreviousUrlAction(action)) {
    if (previousState !== action.previousUrl) {
      return action.previousUrl;
    }
  }

  return previousState;
}
